import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const statusBadgeClass = status => {
	switch ((status || '').toLowerCase()) {
		case 'assigned':
			return 'bg-blue-100 text-blue-800'
		case 'completed':
			return 'bg-amber-100 text-amber-800'
		case 'approved':
			return 'bg-green-100 text-green-800'
		case 'paid':
			return 'bg-emerald-100 text-emerald-800'
		default:
			return 'bg-gray-100 text-gray-800'
	}
}

export default function MyTrainingsTableRow({ training }) {
	const { t } = useTranslation()
	const startDate = training.data_rozpoczecia
	const endDate = training.data_zakonczenia
	const trainingStartDate = startDate ? startDate.substring(0, 10) : '—'
	const trainingEndDate = endDate ? endDate.substring(0, 10) : trainingStartDate
	const trainingDate = trainingStartDate === trainingEndDate
		? trainingStartDate
		: `${trainingStartDate} - ${trainingEndDate}`
	const statusLabel = training.status
		? t(`trainings.list.statusOptions.${training.status}`, { defaultValue: training.status })
		: '—'

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-3 px-4 border-b border-gray-200">
				<Link
					to={`/centrumSzkolen/moje-szkolenia/details/${training._id}`}
					className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
				>
					{training.nazwa || '—'}
				</Link>
			</td>
			<td className="py-3 px-4 border-b border-gray-200">
				<span className="text-gray-900">{training.placowkaName || '—'}</span>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 whitespace-nowrap">
				<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
					{trainingDate}
				</span>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 whitespace-nowrap">
				<span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusBadgeClass(training.status)}`}>
					{statusLabel}
				</span>
			</td>
		</tr>
	)
}
